import { breadcrumbAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  breadcrumbAnatomy.keys,
);

const BreadcrumbTheme = defineMultiStyleConfig({
  baseStyle: {
    container: {
      lineHeight: "16px",
      "& ol": {
        lineHeight: 0,
      },
    },
    separator: {
      height: "16px",
    },
    item: {
      color: "gray.300",
    },
    link: {
      textStyle: "smallBold",
      color: "gray.400",
      "&[aria-current]": {
        color: "primary.600",
      },
      "&[aria-disabled]": {
        cursor: "not-allowed",
        textDecoration: "none",
      },
    },
  },
});

export default BreadcrumbTheme;
